<!-- src\components\VideoPlayer.vue -->
<template>
    <div class="page">
        <div class="background"></div>
        <div class="main">
            <div class="video-player">
                <button v-if="!isInIframe" @click="goBack">
                    <svg fill="#fff" height="1rem" width="1rem" version="1.1" id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"
                        xml:space="preserve">
                        <path
                            d="M320,112H192V48h-32L0,208l160,160h32v-64h160c88.365,0,112,71.635,112,160h48V304C512,197.962,426.038,112,320,112z">
                        </path>
                    </svg>返回</button>
                <h1>视频播放器</h1>
                <video :src="videoUrl" controls autoplay></video>
                <h3 v-if="isInIframe">双击视频全屏播放</h3>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            isInIframe: false // 新增一个变量用于标识是否在 iframe 中
        };
    },
    props: ['fileName'],
    computed: {
        videoUrl() {
            return `${process.env.BASE_URL}videos/${this.fileName}`;
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    },
    created() {
        // 检查是否在 iframe 中
        if (window !== window.top) {
            this.isInIframe = true; // 如果在 iframe 中，则隐藏返回按钮
        }
    }
};
</script>
  
<style scoped>
.page {
    width: 102.4rem;
    height: 57.6rem;
    position: relative;
    /* 设置相对定位 */
}

.background {
    position: absolute;
    top: 0;
    left: 0;
    width: 102.4rem;
    height: 57.6rem;
    background: url(../assets/img/MasterDDSSlicePNGe4d93d0ed3915930e4fa3507b05af898.jpg) 100% no-repeat;
    background-size: 100% 100%;
    filter: brightness(50%) contrast(100%) blur(5px);
    /* filter: blur(30px); */
    /* z-index: 0; */
}

.main {
    /* top: 0;
    left: 0;
    margin: 0%;
    width: 102.4rem;
    height: 57.6rem; */
    position: relative;
    /* z-index: 1; */
    /* 添加其他必要的样式 */
}

.video-player {
    max-width: 80REM;
    margin: 0 auto;
    font-family: Arial, sans-serif;
}

.video-player h1 {
    font-family: 'Source Han Sans-Bold';
    text-align: center;
    font-size: 2REM;
    margin-bottom: 20px;
    color: #fff;
}

.video-player h3 {
    font-family: 'Source Han Sans-Bold';
    text-align: center;
    color: #888;
}

.video-player video {
    width: 100%;
    border-radius: 15px;
    box-shadow: 20px 20px 20px 20px rgba(0, 0, 0, 0.2);
    /* 添加投射阴影 */
}

button {
    font-size: 1REM;
    font-family: 'Source Han Sans-Medium';
    color: #fff;
    border: 2px solid #fff;
    /* 白色边框 */
    border-radius: 5px;
    background-color: rgba(128, 128, 128, 0.6);
    /* 透明灰色背景色，调整最后一个参数控制透明度 */
    padding: 0.5rem;
}

button:hover {
    background-color: rgba(32, 32, 32, 0.6);
}

svg {
    position: relative;
    transform: translateY(-16%);
    margin-right: 0.25rem;
}

@media (max-width: 800px) {
    .video-player {
        max-width: 98%;
    }

    .video-player h1 {
        margin-top: 20px;
        font-size: 24px;
        color: #000;
    }

    .video-player h3 {
        font-size: 16px;
    }

    .video-player video {
        box-shadow: none;
    }

    .background {
        background: none;
        width: auto;
        height: auto;
    }
}
</style>  